import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export default function Collapsible({
    title,
    children,
    isOpen,
    setIsOpen,
    defaultOpen = false,
}) {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);
    const controlled = typeof isOpen === "boolean" && typeof setIsOpen === "function";
    const open = controlled ? isOpen : internalOpen;
    const toggleOpen = () => (controlled ? setIsOpen(!isOpen) : setInternalOpen(!internalOpen));

    return (
        <div className="w-full">
            <button
                onClick={toggleOpen}
                className="w-full flex items-center gap-2 text-left text-xl text-[#d4a017] font-cinzel uppercase font-normal mb-2 cursor-pointer focus:outline-none"
            >
                <FontAwesomeIcon
                    icon={open ? faChevronUp : faChevronDown}
                    className="text-base"
                />
                {title}

            </button>

            <div
                className={`transition-all duration-300 overflow-hidden ${open ? "opacity-100" : "max-h-0 opacity-0"
                    }`}
            >
                <div className="pt-2 px-1">{children}</div>
            </div>
        </div>
    );
}